export default {
  sweetness: `sweetness: __type(name:"WineSweetness") {
    enumValues {
      name
      description
    }
  }`,
  discount_group: `discount_group: __type(name:"DiscountGroup") {
    enumValues {
      name
      description
    }
  }`,
  wine_type: `wine_type: __type(name:"WineType") {
    enumValues {
      name
      description
    }
  }`,
  varietal: `varietal: __type(name:"WineVarietal") {
    enumValues {
      name
      description
    }
  }`,
  series: `series: __type(name:"WineSeries") {
    enumValues {
      name
      description
    }
  }`,
  brand: `series: __type(name:"WineBrand") {
    enumValues {
      name
      description
    }
  }`,
  attributes: `series: __type(name:"WineAttributes") {
    enumValues {
      name
      description
    }
  }`,
  collections: `series: __type(name:"WineCollections") {
    enumValues {
      name
      description
    }
  }`,
  region: `series: __type(name:"WineRegion") {
    enumValues {
      name
      description
    }
  }`,
  bodyicon: `series: __type(name:"BodyIcon") {
    enumValues {
      name
      description
    }
  }`,
  sizeicon: `series: __type(name:"SizeIcon") {
    enumValues {
      name
      description
    }
  }`,
  typeicon: `series: __type(name:"TypeIcon") {
    enumValues {
      name
      description
    }
  }`,
  varietalicon: `series: __type(name:"VarietalIcon") {
    enumValues {
      name
      description
    }
  }`
}
